import type { ResetPasswordWithCardNumberCredentials } from "@/modules/auth/common/types";
import { setResetFields } from "@/modules/auth/state";
import { resetWithCardNumberValidationSchema } from "@/modules/auth/validations";
import { useAppDispatch } from "@/shared/hooks";
import { Button } from "@ab.uitools/ui-library/components/Button";
import { FormContainer } from "@ab.uitools/ui-library/components/FormContainer";
import { useTranslation } from "react-i18next";
import type * as Yup from "yup";

import { CardNumberFormFields } from "./CardNumberFormFields";

interface Props {
  onSubmit: (
    values: ResetPasswordWithCardNumberCredentials,
  ) => void;
  isLoading: boolean;
}

const initialValues = {
  cardNumber: "",
};

export const CardNumberForm = ({ onSubmit, isLoading }: Props) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const handleSubmit = (
    val: ResetPasswordWithCardNumberCredentials,
    isDirty: boolean,
  ) => {
    if (isDirty) {
      const cardNumber = val.cardNumber?.replace(/\s/g, "");
      dispatch(setResetFields(val));
      onSubmit({ cardNumber });
    }
  };

  return (
    <div>
      <FormContainer
        className="full-width"
        onSubmit={(data, formState) => handleSubmit(data, formState.isDirty)}
        mode="onBlur"
        reValidateMode="onBlur"
        validationScheme={resetWithCardNumberValidationSchema({ t }) as Yup.AnyObjectSchema}
        initialValues={initialValues}
        shouldFocusError
      >
        <CardNumberFormFields/>
        <Button
          isLoading={isLoading}
          className="full-width mt-32"
          buttonActionType="submit"
          buttonText={t("general.confirm")}
          data-testid="reset-card-number-button"
          data-ga-id="reset-card-number-button"
          data-ga-action="Reset action with card number"
        />
      </FormContainer>
    </div>
  );
};
